var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CTabs',{staticClass:"nav-tabs-boxed",attrs:{"variant":"tabs"}},[_c('CTab',{attrs:{"title":"Regras"}},[_c('RegrasAba')],1),_c('CTab',{attrs:{"title":"Carteiras"}},[_c('CarteirasAba')],1),_c('CTab',{attrs:{"title":"Bloqueios"}},[_c('BloqueiosAba')],1),_c('CTab',{attrs:{"title":"Configurações"}},[_c('ConfiguracoesAba')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }